import { useCallback } from "react"
import { useIntl } from "react-intl"

export default function useFormattedError() {

    const { formatMessage } = useIntl()

    const getErrorMessageFromCode = useCallback((code) => {

        if (!(typeof code === 'number' || typeof code === 'string')) return formatMessage({ id: 'error' })

        const codeString = '' + code
        const firstNum = codeString[0]

        let translationKey

        if (firstNum === '4') {
            switch (codeString) {
                /* bad request */
                case '400': translationKey = 'badRequest'; break; 
                /* invalid credentials */
                case '401': translationKey = 'invalidCredentials'; break; 
                /* no access rights */
                case '403': translationKey = 'noAccessRights'; break; 
                /* not found */
                case '404': translationKey = 'notFound'; break; 
                /* too many requests */
                case '429': translationKey = 'tooManyRequests'; break; 
            }
        } else if (firstNum === '5') {
            switch (codeString) {
                /* server error */
                case '500': translationKey = 'serverError'; break; 
                /* service temporarily unavailable, please try again later */
                case '503': translationKey = 'serviceUnavailable'; break; 
            }
        }

        const message = `${formatMessage({ id: 'error' })}: ${translationKey ? formatMessage({ id: translationKey }) : codeString}`

        return message

    }, [formatMessage])

    return {
        getErrorMessageFromCode,
    }
}